import {
  getGridStringOperators,
  getGridBooleanOperators,
} from "@mui/x-data-grid-pro";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { PendingChip } from "@poseidon/ui/components/RagChip";
import { Chip } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import HelpIcon from "@mui/icons-material/Help";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PendingIcon from "@mui/icons-material/Pending";
import { timestampColumn } from "../../DataGrid/ColumnHelpers";
import VerifiedIcon from "@mui/icons-material/GppGood";
import UnverifiedIcon from "@mui/icons-material/GppBad";

const StatusChip = ({ status }) => {
  if (status === "fail") {
    return (
      <Chip
        size="small"
        color="error"
        icon={<CancelIcon color="error" />}
        label="Fail"
        variant="outlined"
      />
    );
  }

  if (status === "highRisk") {
    return (
      <Chip
        size="small"
        color="warning"
        icon={<HelpIcon color="warning" />}
        label="High Risk"
        variant="outlined"
      />
    );
  }

  if (status === "pass" || status === "lowRisk") {
    return (
      <Chip
        size="small"
        color="success"
        icon={<CheckCircleIcon color="warning" />}
        label={status === "pass" ? "Pass" : "Low Risk"}
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      size="small"
      color="info"
      icon={<PendingIcon color="info" />}
      label="Pending"
      variant="outlined"
    />
  );
};
const PepStatusChip = ({ status }) => {
  if (status === "yes") {
    return (
      <Chip
        size="small"
        color="error"
        icon={<CancelIcon color="error" />}
        label="is PEP"
        variant="outlined"
      />
    );
  }

  if (status === "no") {
    return (
      <Chip
        size="small"
        color="success"
        icon={<CheckCircleIcon color="warning" />}
        label="non PEP"
        variant="outlined"
      />
    );
  }

  return (
    <Chip
      size="small"
      color="info"
      icon={<PendingIcon color="info" />}
      label="Pending"
      variant="outlined"
    />
  );
};

export const columns = [
  {
    field: "id",
    headerName: "ID",
    width: 90,
    filterOperators: () => {
      getGridStringOperators().filter(
        (operator) =>
          operator.value === "contains" || operator.value === "equals"
      );
    },
  },
  {
    field: "sailorNumber",
    headerName: "Sailor #",
    width: 90,
    filterOperators: () => {
      getGridStringOperators().filter(
        (operator) =>
          operator.value === "contains" || operator.value === "equals"
      );
    },
  },
  {
    field: "displayName",
    headerName: "Full name",
    description: "This column has a value getter and is not sortable.",
    width: 260,
    valueGetter: (params) =>
      params.row.firstName
        ? `${params.row.firstName || ""} ${params.row.lastName || ""}`
        : params.row.displayName,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains" || operator.value === "equals"
    ),
  },
  {
    field: "email",
    headerName: "Email Address",
    width: 260,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains" || operator.value === "equals"
    ),
  },
  {
    field: "emailVerified",
    headerName: "Verified",
    type: "boolean",
    headerAlign: "left",
    renderCell: ({ value }) => {
      return value ? (
        <VerifiedIcon color="success" />
      ) : (
        <UnverifiedIcon color="disabled" />
      );
    },
    width: 150,
    filterOperators: getGridBooleanOperators(),
  },
  timestampColumn({
    field: "createdAt",
    headerName: "Created At",
  }),
  timestampColumn({
    field: "lastSignIn",
    headerName: "Last Signed In",
  }),
  {
    field: "kycAmlStatus",
    headerName: "KYC/AML Designation",
    width: 210,
    renderCell: ({ row: sailor }) => (
      <WithDoc
        docRef={`sailorRiskProfiles/${sailor.id}`}
        Component={({ data: sailorRiskProfile }) => (
          <StatusChip status={sailorRiskProfile.kycAmlStatus ?? "pending"} />
        )}
        FallbackComponent={PendingChip}
      />
    ),
  },
  {
    field: "pepStatus",
    headerName: "PEP Status",
    width: 210,
    renderCell: ({ row: sailor }) => (
      <WithDoc
        docRef={`sailorRiskProfiles/${sailor.id}`}
        Component={({ data: sailorRiskProfile }) => (
          <PepStatusChip status={sailorRiskProfile.pepStatus ?? "pending"} />
        )}
        FallbackComponent={PendingChip}
      />
    ),
  },
  {
    field: "idvStatus",
    headerName: "ID&V Status",
    width: 210,
    renderCell: ({ row: sailor }) => (
      <WithDoc
        docRef={`sailorRiskProfiles/${sailor.id}`}
        Component={({ data: sailorRiskProfile }) => (
          <StatusChip status={sailorRiskProfile.idvStatus ?? "pending"} />
        )}
        FallbackComponent={PendingChip}
      />
    ),
  },
];
